module.exports = __webpack_public_path__ + "img/LOGO_ESUS_FEEDBACK.3d8e9dc4.svg";